<template>
  <div class="main-content">
    <div class="section__content section__content--p30">
      <div class="container-fluid">
        <div class="row">
          <div class="col-xl-12">
            <div class="chart-info">
              <div class="chart-info__left">
                <h3 class="title-1">
                  {{ text('encoding_jobs_header') }} ({{ totalJobs }})
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <v-card class="m-b-50">
              <div class="el-loading-mask" v-if="loading || tableLoading">
                <div class="el-loading-spinner">
                  <svg viewBox="25 25 50 50" class="circular">
                    <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                  </svg>
                </div>
              </div>
              <div class="card-header">
                <div class="row">
                  <div class="col-md-6 p-l-10">
                    <v-btn
                      v-show="selected.length"
                      outline small
                      color="error"
                      class="mb-0"
                      @click="jobsRemoveDialog=true">
                      {{ text('delete_selected_btn') }}
                    </v-btn>
                  </div>
                  <div class="col-md-6" style="padding-right: 22px;">
                    <!--div class="btn-group" style="width: 100%">
                      <label for="search" class="p-r-10 v-align">Search:</label>
                      <input type="search" id="search" class="form-control">
                    </div-->
                  </div>
                </div>
              </div>
              <div class="table-responsive jobs">
                <table class="align-middle mb-0 table table-borderless table-hover table-striped">
                  <thead>
                  <tr>
                    <th class="checkbox" v-if="jobs.length">
                      <v-checkbox
                        hide-details
                        class="m-0 p-0"
                        v-model="allSelected"
                        @change="toggleAll">
                      </v-checkbox>
                    </th>
                    <th>{{ text('title') }}</th>
                    <th>{{ text('format') }}</th>
                    <th>{{ text('status') }}</th>
                    <th>{{ text('created') }}</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(job, i) of jobs"
                      :key="job.id"
                      @mouseover="setActiveRow(i)"
                      @mouseleave="setActiveRow(-1)">
                    <td class="checkbox">
                      <v-checkbox
                        hide-details
                        :value="job.id"
                        :key="job.id"
                        class="m-0 p-0"
                        v-model="selected">
                      </v-checkbox>
                    </td>
                    <td @click="showJobDetail(job.id)">
                      <v-tooltip top v-if="job.priority < 0">
                        <template v-slot:activator="{ on }">
                          <i class="fa fa-arrow-up urgent p-r-10" v-on="on"></i>
                        </template>
                        {{ text('high_priority') }}
                      </v-tooltip>
                      {{ job.name }}
                    </td>
                    <!--td class="config-param-column">
                      <div class="config-param">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <i class="zmdi zmdi-view-subtitles"
                               :class="{'disabled': !areThereOutputSubtitles(job)}"
                               v-on="on">
                            </i>
                          </template>
                          <span v-if="areThereOutputSubtitles(job)">Subtitles in the output</span>
                          <span v-else>No output subtitles</span>
                        </v-tooltip>
                      </div>
                      <div class="config-param">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <i class="zmdi zmdi-archive"
                               :class="{'disabled': !areThereOutputZip(job)}"
                               v-on="on">
                            </i>
                          </template>
                          <span v-if="areThereOutputZip(job)">Zip compression in the output</span>
                          <span v-else>No compression in the output</span>
                        </v-tooltip>
                      </div>
                      <div class="config-param">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <i class="zmdi zmdi-lock"
                               :class="{'disabled': !areThereOutputDRM(job)}"
                               v-on="on">
                            </i>
                          </template>
                          <span v-if="areThereOutputDRM(job)">DRM protected output</span>
                          <span v-else>DRM-free output</span>
                        </v-tooltip>
                      </div>
                    </td-->
                    <td @click="showJobDetail(job.id)">
                      <span class="text-uppercase">{{ getInputFormat(job) }}</span>
                      <i class="zmdi zmdi-trending-flat text-muted p-l-10 p-r-5"></i>
                      <span class="text-uppercase">{{ getOutputFormat(job) }}</span>
                    </td>
                    <td @click="showJobDetail(job.id)" style="width: 200px;">
                      <div v-if="jobStatus(job) !== 'in_progress'">
                        <i class="fa fa-clock job-status--paused"
                           v-if="jobStatus(job) === 'pending'">
                        </i>
                        <i class="fa fa-circle-notch fa-spin job-status--finished"
                           v-if="jobStatus(job) === 'processing'">
                        </i>
                        <i class="fa fa-check-circle job-status--finished"
                           v-if="jobStatus(job) === 'done'">
                        </i>
                        <i class="fa fa-exclamation-circle job-status--failed"
                           v-if="jobStatus(job) === 'input_failed' || jobStatus(job) === 'output_failed'">
                        </i>
                        <span class="p-l-10">{{ text(jobStatus(job)) }}</span>
                      </div>
                      <div v-else>
                        <div class="text-center">{{ job.outputs[0].progress }}%</div>
                        <div class="progress-bar-xs progress progress-bar-animated-alt">
                          <div class="progress-bar job-status--bg-process"
                               role="progressbar"
                               :style="{ width: job.outputs[0].progress + '%' }"></div>
                        </div>
                      </div>
                    </td>
                    <td @click="showJobDetail(job.id)" style="width: 200px;">
                      {{ formatCreateTime(job.create_time) }}
                    </td>
                    <td class="delete">
                      <v-btn
                        v-if="activeRow === i"
                        text icon
                        class="m-0"
                        @click.stop="openDeleteJobDialog(job)">
                        <i class="zmdi zmdi-delete text-danger" style="font-size: 18px;"></i>
                      </v-btn>
                    </td>
                  </tr>
                  <tr v-if="!loading && !jobs.length" class="no-hover">
                    <td class="text-center" colspan="7">
                      <div class="m-b-30 m-t-30">
                        {{ text('no_jobs') }}
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="text-center card-footer p-t-20 p-b-20" v-show="this.totalJobs > 10">
                <paginate
                  :limit=this.limit
                  :offset=this.offset
                  :total=this.totalJobs
                  :forcePage=this.forcePage
                  @onPageChange="onPageChange">
                </paginate>
              </div>
            </v-card>
          </div>
        </div>
        <!-- Jobs Remove Dialog -->
        <v-dialog v-model="jobsRemoveDialog" max-width="500" persistent>
          <v-card>
            <v-card-title class="headline">
              {{ text('delete_jobs_header') }}
            </v-card-title>
            <v-card-text>
              <div class="row p-b-20">
                <div class="col-md-12">
                  {{ text('delete_jobs_text') }}
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed small text
                     @click="jobsRemoveDialog = false">{{ text('no_btn') }}</v-btn>
              <v-btn depressed small color="error"
                     @click="deleteSelectedJobs()">{{ text('yes_btn') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Single Job Remove Dialog -->
        <v-dialog v-model="jobRemoveDialog" max-width="500" persistent>
          <v-card>
            <v-card-title class="headline">
              {{ text('delete_job_header') }}
            </v-card-title>
            <v-card-text>
              <div class="row p-b-20">
                <div class="col-md-12">
                  {{ text('delete_job_text') }} {{ deletedJob.name }}?
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed small text
                     @click="jobRemoveDialog = false">{{ text('no_btn') }}</v-btn>
              <v-btn depressed small color="error"
                     @click="deleteJob()">{{ text('yes_btn') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import Paginate from '@/components/shared/Paginate.vue';
import { JOB_TYPES, INPUT_STATES, OUTPUT_STATES } from '@/components/transcoding/shared/types';
import { sleep } from '@/helpers/utils';

export default {
  components: {
    Paginate,
  },
  created() {
    this.$store.commit('setPageLoader');
    this.loadData(true);
    this.pollData();
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
  data() {
    return {
      activeRow: -1,
      limit: 20,
      offset: 0,
      forcePage: 0,
      tableLoading: false,
      allSelected: false,
      selected: [],
      inputStates: INPUT_STATES,
      outputState: OUTPUT_STATES,
      polling: null,
      jobsRemoveDialog: false,
      jobRemoveDialog: false,
      deletedJob: {},
    };
  },
  computed: {
    loading() {
      return this.$store.getters.isDataLoaded;
    },
    totalJobs() {
      return this.$store.getters['jobsOverview/getTotalFileJobs'];
    },
    jobs() {
      return this.$store.getters['jobs/getFileJobs'];
    },
    dict() {
      return this.$store.getters.dictionary;
    },
  },
  methods: {
    pollData() {
      this.polling = setInterval(() => {
        this.loadData(false);
      }, 10000);
    },
    loadData(notification) {
      this.$store.dispatch('jobsOverview/getOverview')
        .then(() => {
          if (this.$route.query.page) {
            const offset = (this.$route.query.page - 1) * this.limit;
            if (offset > this.totalJobs || offset < 0) {
              this.offset = 0;
              this.updateRoute(1);
            } else {
              this.offset = offset;
            }
          }
          const args = {
            limit: this.limit,
            offset: this.offset,
          };
          this.$store.dispatch('jobs/getFileJobs', args)
            .then(() => {
              if (!this.$route.query.page) {
                this.updateRoute(1);
              }
            })
            .catch((errorMsg) => {
              if (notification) {
                this.$toasted.error(errorMsg, {
                  theme: 'toasted-primary',
                  position: 'top-center',
                  duration: 10000,
                });
              }
            })
            .finally(() => this.$store.commit('resolvePageLoader'));
        })
        .catch((errorMsg) => {
          this.$store.commit('resolvePageLoader');
          if (notification) {
            this.$toasted.error(errorMsg, {
              theme: 'toasted-primary',
              position: 'top-center',
              duration: 10000,
            });
          }
        });
    },
    jobStatus(job) {
      if (job.input.state === 'pending') {
        return 'pending';
      }
      if (job.input.state === 'processing') {
        return 'processing';
      }
      if (job.input.state === 'error') {
        return 'input_failed';
      }
      if (job.outputs[0].state === 'pending') {
        return 'processing';
      }
      if (job.outputs[0].state === 'error') {
        return 'output_failed';
      }
      if (job.outputs[0].state === 'success') {
        return 'done';
      }
      return 'in_progress';
    },
    setActiveRow(i) {
      this.activeRow = i;
    },
    showJobDetail(id) {
      this.$router.push({
        name: 'FileTranscodingJobDetailPage',
        params: {
          id,
        },
      });
    },
    onPageChange(selectedPage) {
      this.tableLoading = true;
      this.selected = [];
      this.offset = selectedPage * this.limit - this.limit;

      this.updateRoute(selectedPage);

      const args = {
        limit: this.limit,
        offset: this.offset,
      };
      this.$store.dispatch('jobs/getFileJobs', args)
        .then(() => this.tableLoading = false)
        .catch((errorMsg) => {
          this.$toasted.error(errorMsg, {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 10000,
          });
        });
    },
    updateRoute(selectedPage) {
      const query = Object.assign({}, this.$route.query, { page: selectedPage });
      this.$router.push({ query });
    },
    openDeleteJobDialog(job) {
      this.deletedJob = Vue.util.extend({}, job);
      this.jobRemoveDialog = true;
    },
    deleteJob() {
      if (!this.deletedJob.id) return;
      this.$store.dispatch('jobs/deleteJob', this.deletedJob.id)
        .then(() => {
          this.$toasted.success(this.text('delete_jobs_popup'), {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 5000,
          });
          this.loadData(true);
          for (let i = 0; i < this.selected.length; i++) {
            if (this.selected[i] === this.deletedJob.id) {
              this.selected.splice(i, 1);
            }
          }
          this.deletedJob = {};
          this.jobRemoveDialog = false;
        })
        .catch((errorMsg) => {
          this.jobRemoveDialog = false;
          this.$toasted.error(errorMsg, {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 7000,
          });
        });
    },
    deleteSelectedJobs() {
      if (this.selected.length === 0) return;
      this.$store.dispatch('jobs/deleteJobs', this.selected)
        .then(() => {
          this.$toasted.success(this.text('delete_jobs_popup'), {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 5000,
          });
          this.selected = [];
          this.jobsRemoveDialog = false;
          sleep(500).then(() => {
            this.loadData(true);
          });
        })
        .catch((errorMsg) => {
          this.jobsRemoveDialog = false;
          this.$toasted.error(errorMsg, {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 7000,
          });
        });
    },
    formatCreateTime(createTime) {
      return moment(createTime).format('YYYY-MM-DD HH:mm');
    },
    toggleAll(checked) {
      if (checked) {
        const selected = [];
        for (let i = 0; i < this.jobs.length; i++) {
          selected.push(this.jobs[i].id);
        }
        this.selected = selected;
      } else {
        this.selected = [];
      }
    },
    getInputFormat(job) {
      if (!job.input.url.includes('.')) return 'N/A';
      const ext = job.input.url.split('.').pop();
      const parts = ext.split('&');
      return parts[0];
    },
    getOutputFormat(job) {
      if (job.outputs.length === 1) {
        const format = JOB_TYPES[job.outputs[0].format] || 'N/A';
        return format === 'copy' ? this.getInputFormat(job) : format;
      }
      if (job.outputs.length > 1) {
        const formats = [];
        for (let i = 0; i < job.outputs.length; i++) {
          const format = JOB_TYPES[job.outputs[i].format] || 'N/A';
          formats.push(format === 'copy' ? this.getInputFormat(job) : format);
        }
        return `(${formats.join(', ')})`;
      }
      return 'N/A';
    },
    areThereOutputSubtitles(job) {
      for (let i = 0; i < job.outputs.length; i++) {
        const output = job.outputs[i];
        for (const j in output.map) {
          const item = output.map[j];
          if (item.source && item.source.includes('.vtt')) {
            return true;
          }
        }
      }
      return false;
    },
    areThereOutputZip(job) {
      for (let i = 0; i < job.outputs.length; i++) {
        if (job.outputs[i].zip) return true;
      }
      return false;
    },
    areThereOutputDRM(job) {
      for (let i = 0; i < job.outputs.length; i++) {
        if (job.outputs[i].drm) return true;
      }
      return false;
    },
    text(code) {
      // eslint-disable-next-line no-prototype-builtins
      if (this.dict.hasOwnProperty(code)) {
        return this.dict[code];
      }
      return code;
    },
  },
  watch: {
    $route(to, from) {
      if (from.query.page && to.query.page) {
        this.forcePage = Number(to.query.page);
      }
    },
    selected(newVal, oldVal) {
      if (newVal.length === 0) {
        this.allSelected = false;
      } else this.allSelected = newVal.length === this.jobs.length;
    },
  },
};
</script>
